export default __webpack_public_path__ + "2c8e8e557d185b275413a73c85e3844d.png";